@if (loading) {
  <div class="text-center">
    <div class="spinner-border text-blue"></div>
  </div>
}

@if (!loading) {
  @if (error) {
    <div class="alert alert-danger m-0">
      Error has occurred while retrieving Slipcase news feed.
    </div>
  }
  @if (!error) {
    @if (newsItems.length >0) {
      <div class="divide-y">
        @for (item of newsItems; track item) {
          <div>
            <app-news-item [item]="item" [showTime]="true"></app-news-item>
          </div>
        }
      </div>
    }
    @if (newsItems.length == 0) {
      <div>
        <div class="empty">
          <div class="empty-title">No Slipcase news available</div>
        </div>
      </div>
    }
  }
}